export const CODIGO_ASESOR = {
    SURA: '4999'
}
